import { render, staticRenderFns } from "./ArticleTranslation.vue?vue&type=template&id=49c14370&"
import script from "./ArticleTranslation.vue?vue&type=script&lang=js&"
export * from "./ArticleTranslation.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTranslation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports